import { Component, OnInit, Input, Inject } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MasterTemplateCategory } from '../Enum/common.enum';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-importMyDrive',
  templateUrl: './importMyDrive.component.html',
  styleUrls: ['./importMyDrive.component.scss'] 
})

export class ImportMyDriveListComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  
  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;
  menuHeaderMyDrive: any=[]=[];
  menuHeader: any=[]=[];

  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);

  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  parentID: number = 0;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  SharedWithMeMyDriveactive: boolean = false;

  TypeId: number;

  MyDrivefoldersList: any;
  activeNodeFileManager: string = ""; 
  FileManagerFolderListLeft: any;
  fileManagerID: string = "";
  foldersMyDriveListShow: boolean = false;
  selectButtonMyDriveShow: boolean = false;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  //dialogRef: MatDialogRef<any, any>;
  
  constructor(public dialogRef: MatDialogRef<ImportMyDriveListComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private statusConst: StatusConstant,private loaderService: LoaderService,
    private settingsService: SettingService,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }  
  
  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
   

    this.activeNodeFileManager = "";
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];  
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
   

  }  

  getFileManagerFolderList() {
    var reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.settingsService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          if (this.FileManagerFolderListLeft != null && this.FileManagerFolderListLeft != undefined) {
            this.dataSourceFileManager.data = this.FileManagerFolderListLeft;
          }
        }
        else {
        }
      }
      else {
      }
    });

  }

  getFileManagerFoldersList(folderId) {
    var reqModel = {
      fileManagerItemID: folderId,
      name: "",
      pageIndex: 0,
      pageSize: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.settingsService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConst.statusSuccess) {
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if (this.hierarchyList == null || this.hierarchyList == null) {
          this.menuHeaderMyDrive = [];
        } else {
          this.menuHeaderMyDrive = [];
          this.hierarchyList.forEach(e => {
            this.menuHeaderMyDrive.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
          });
        }

        this.MyDrivefoldersList.forEach(e => {
          e.isChecked = false;
        });
        if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
          this.MyDrivefoldersList = [];
          this.foldersMyDriveListShow = true;
        } else {
          this.foldersMyDriveListShow = false;
        }
      }
    });
  }

  closeAll(){
    this.dialog.closeAll();
  }

  GetAllMyDrive() {
    this.activeNodeFileManager = "";
    this.dataSourceFileManager.data = [];
    this.selectButtonMyDriveShow = false;
    this.isShowMyDrive = true;
    this.isShowForm = false;
    this.isSharedWithMe = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }
 

  showChildFolders(folder) {
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.SharedWithMeMyDriveactive = false;
    this.activeNodeFileManager = folder.fileManagerItemID;
    this.getFileManagerFoldersList(folder.fileManagerItemID);
  }


  getSharedWithMeMyDrive() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.settingsService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeMyDriveFolderList = this.responseHolder.data;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
        else {
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.SharedWithMeMyDriveFolderList = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }

  breadCrumbMyDriveMainClick() {
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.menuHeaderMyDrive = [];
    this.activeNodeFileManager = "";
    this.getFileManagerFoldersList(0);
    //this.getFileManagerFolderList(); 
    this.selectButtonMyDriveShow = false;
    this.foldersMyDriveListShow = false;
  }

  breadCrumbMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.getFileManagerFoldersList(data.id);
  }

  radioChangeMyDrive(form) {
    if (form.isFile == false) {
      this.MyDrivefoldersList.forEach(e => {
        e.isChecked = false
      });
      this.selectButtonMyDriveShow = false;
      this.showChildFolders(form);
      return;
    }
    if (form.isFile == true) {
      if (form.fileType != null || form.fileType != "" || form.fileType != undefined) {
        if (form.fileType != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          //this.PlaceholderName = form.name;
          //this.filePath = form.azureblobPath;
          // if (form.fileSize) {
          //   this.fileSizeFromMyDrive = form.fileSize;
          // } else {
          //   this.fileSizeFromMyDrive = "";
          // }

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });

          this.fileManagerID = form.fileManagerItemID;
        }
      }
      if (form.fileType == null || form.fileType == "" || form.fileType == undefined) {
        var fileName = form.name.split('.').pop();
        if (fileName != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          //this.PlaceholderName = form.name;
          //this.filePath = form.azureblobPath;

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });
          this.fileManagerID = form.fileManagerItemID;
        }
      }
    }
  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

    // ===== Shared with me My Drive ======//

    breadCrumbMainSHaredWithMeMyDriveClick() {
      this.selectButtonMyDriveShow = false;
      this.menuHeaderMyDrive = [];
      this.getSharedWithMeMyDrive();
    }
  
    breadCrumbSharedWithMeMyDrive(menu, index) {
      this.selectButtonMyDriveShow = false;
      this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
      if (menu[index] && menu[index].items && menu[index].items.length) {
        this.MyDrivefoldersList = menu[index].items;
      }
      this.foldersMyDriveListShow = false;
      var data = this.menuHeaderMyDrive[index];
      this.showChildFoldersSharedWithMeMyDrive({ type: 1, id: data.id, isFile: data.isFile, name: data.label });
    }

    showChildFoldersSharedWithMeMyDrive(folder) {
      this.isShowMyDrive = false;
      this.isSharedWithMeMyDrive = false;
      this.selectButtonMyDriveShow = false;
      this.isSharedWithMeMyDrive = true;
      this.SharedWithMeMyDriveactive = true;
      var folderId;
      if (folder.isFile == true) {
        this.menuHeaderMyDrive = [];
      }
      if (folder.fileManagerItemID == undefined) {
        folderId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        folderId = folder.fileManagerItemID;
      }
  
      this.menuHeaderMyDrive.push({
        label: folder.name,
        id: folderId,
        icon: 'navigate_next',
        isFile: folder.isFile
      });
      this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
      this.ChildFoldersSharedWithMeMyDrive(folder);
    }

    ChildFoldersSharedWithMeMyDrive(folder) {
      var folderId;
      if (folder.fileManagerItemID == undefined) {
        folderId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        folderId = folder.fileManagerItemID;
      }
      var reqModel = {
        fileManagerItemID: folderId,
        name: "",
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
        permissionType: 0
      }
      this.settingsService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
        if (response.status == this.statusConst.statusSuccess) {
          this.SharedWithMeMyDriveFolderList = response.data;//.children;
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          if (this.SharedWithMeMyDriveFolderList == null || this.SharedWithMeMyDriveFolderList.length == 0) {
            this.SharedWithMeMyDriveFolderList = [];
          }
        } else {
  
        }
      });
    }
  
  
    radioChangeMyDriveSharedWithMe(form) {
      var folderId;
      if (form.isFile == false) {
        if (form.fileManagerItemID == undefined) {
          folderId = form.id;
        }
        if (form.fileManagerItemID != undefined) {
          folderId = form.fileManagerItemID;
        }
        this.menuHeaderMyDrive.push({
          label: form.name,
          id: folderId,
          icon: 'navigate_next',
          isFile: form.isFile
        });
        this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
        this.ChildFoldersSharedWithMeMyDrive(form);
        return;
      }
  
  
      if (form.isFile == true) {
        if (form.fileType != "pdf") {
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
  
        this.selectButtonMyDriveShow = true;
        // this.PlaceholderName = form.name.substring(0, 30);//form.name; //get first 30 chars
        // this.PlaceholderName = form.name;//form.name; //get first 30 chars
        // this.PlaceholderID = "0";
        // if (form.azureblobPath == null || form.azureblobPath == undefined) {
        //   this.filePath = form.url;
        // }
        // if (form.url == null || form.url == undefined) {
        //   this.filePath = form.azureblobPath;
        // }
        // if (form.fileSize) {
        //   this.fileSizeFromMyDrive = form.fileSize;
        // }
        // if (!form.fileSize) {
        //   this.fileSizeFromMyDrive = "";
        // }
  
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          e.isChecked = false;
        });
  
        if (form.fileManagerItemID == undefined) {
          this.fileManagerID = form.id;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            if (e.id == form.id) {
              e.isChecked = true;
            }
          });
        }
        if (form.fileManagerItemID != undefined) {
          this.fileManagerID = form.fileManagerItemID;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true;
            }
          });
        }
      }
  
    }
    

    AddDocumentfromMyDrive(){

    }
   
}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}